
				var addMethods = require("../../node_modules/workerize-loader/dist/rpc-wrapper.js")
				var methods = ["format"]
				module.exports = function() {
					var w = new Worker(__webpack_public_path__ + "827aef9fe089ee87b169.worker.js", { name: "[hash].worker.js" })
					addMethods(w, methods)
					
					return w
				}
			